export const prerender = true

// Audience type for landing page segmentation
export type Audience = "students" | "universities"
